<template>
  <component
    :is="logicType ? 'edn-switch' : 'edn-check'"
    v-model="Value"
    :label="label"
    :readonly="readonly"
    :required="required"
    :tooltip="tooltip"
    :disabled="disabled"
    v-on="$listeners"
    :labelStyles="$attrs.labelStyles"
  />
</template>

<script>
import { ednRequired } from './mixins/ednRequired'
import { ednValue } from './mixins/ednValue'

export default {
  name: 'IrisEdnLogic',
  mixins: [ednRequired, ednValue],
  inheritAttrs: false,
  props: {
    logicType: {
      type: Number,
      default: 0,
    },
    label: {
      type: String,
    },
    readonly: {
      type: Boolean,
      default: false,
    },
    required: {
      type: Boolean,
      default: false,
    },
    disabled: {
      type: Boolean,
    },
    tooltip: {
      type: String,
    },
    value: {
      type: Boolean,
      default: false,
    },
  },
  computed: {},
}
</script>
